import { BaseModel } from './base.model';
import { EmailModel } from './email.model';
import { UserTypeModel } from './user-type.model';
import { AccessRules } from '../enum/access_rules';
import { InstituteDepartamentModel } from './institute-departaments.model';

export class UserModel extends BaseModel {
    id: number;

    name: string;
    password: string;
    user_type_id: number;
    login: string;
    /** Associations */
    email: EmailModel;
    user_type: UserTypeModel;
    telegram_chat_id: number;
    send_user_email: boolean;
    signature_token: number;
    institute_departaments: InstituteDepartamentModel[];
    signature_image: any;

    // Local Prop Only
    is_admin: boolean;

    static validate(user: UserModel): boolean {
        return !!(user.name && user.email.address && user.user_type_id);
    }

    isAdmin(): boolean {
        this.is_admin =
        this.user_type &&
        this.user_type.access_rule &&
        this.user_type.access_rule <= AccessRules['level_ii'];

        return this.is_admin;
    }

    constructor(user?: UserModel) {
        super();

        this.id = user ? user.id || null : null;

        this.name = user ? user.name || null : null;
        this.password = user ? user.password || null : null;
        this.user_type_id = user ? user.user_type_id || null : null;
        this.login = user ? user.login || null : null;

        this.email = user ? user.email || new EmailModel() : new EmailModel();
        this.user_type = user ? user.user_type || new UserTypeModel() : new UserTypeModel();
        this.telegram_chat_id = user ? user.telegram_chat_id || null : null;
        this.signature_token = user ? user.signature_token || null : null;
        this.send_user_email = user ? user.send_user_email || null : null;
        this.institute_departaments = user ? user.institute_departaments || null : null;

        // Local Prop Only
        // this.is_admin = user ? user.is_admin || null : null;

        // Run Prop Update
        this.isAdmin();
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/user.model.ts